module.exports = __webpack_public_path__ + "static/media/monument.3cdbfcdb.svg";